module.exports = __webpack_public_path__ + "static/media/link_add_normal.93bce20a.svg";